import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ISiteMonitoringKeyMetricComponent, KeyMetricsBaseMixin } from '../key-metrics.mixin';
import { IStatusCardConfig } from '../status-count-card/status-card-config.interface';
import { ISiteMonitoringKeyMetricOptimisticSettings } from '../../../model/key-metrics/site-monitoring-key-metric-optimistic-settings.interface';
import { contentStatusCardConfig } from '../key-metric-viewer-config.constant';

@Component({
  selector: 'amp-key-metrics-content-accuracy',
  templateUrl: './key-metrics-content-accuracy.component.html',
  styleUrls: ['./key-metrics-content-accuracy.component.scss'],
  inputs: ['config', 'monitoringData', 'monitoringDate', 'monitoringDataDataState', 'showCompactView'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KeyMetricsContentAccuracyComponent extends KeyMetricsBaseMixin<ISiteMonitoringKeyMetricOptimisticSettings>() implements ISiteMonitoringKeyMetricComponent {
  cardConfig: IStatusCardConfig = contentStatusCardConfig;

  constructor() {
    super();
  }
}
